// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__DbR8t","navItem":"Nav_navItem__safcI","navLink":"Nav_navLink__sxDZG"};